import { defaultError } from '@qpr/client-library';
import api, { ApiResult } from '../../api/api-caller';
import initialState, { QueryBuilderState } from './query-builder-state';

const errorHandler = (apiResult: ApiResult): QueryBuilderState => {
  return {
    ...initialState,
    error: apiResult.error || defaultError
  };
};

const extractDataFromResponse = (result: ApiResult) => {
  const { data } = result;

  return data;
};

const doFetchOptions = async (id: string): Promise<ApiResult> => {
  const modelId = id.split('.', 2).join('.');

  const call = {
    body: {
      query: `[${modelId}].organizationitemtype`,
      attributes: 'name(as="title"), id(as="value")'
    },
    method: 'POST'
  };

  const result: ApiResult = await api.asyncCallApi('meaquery', call);

  return result;
};

const doGetOptions = async (fieldName: string, id: string): Promise<QueryBuilderState> => {
  try {
    const optionsResult = await doFetchOptions(id);

    if (!optionsResult.ok) {
      return errorHandler(optionsResult);
    }

    const options: any[] = extractDataFromResponse(optionsResult);

    return { ...initialState, data: { [fieldName]: options } };
  } catch (error) {
    return {
      ...initialState,
      error: { message: 'Server unreachable', details: JSON.stringify(error) }
    };
  }
};

// allow use string to access element
interface IData {
  [key: string]: any;
}
const viewModelCache: IData = {};

export interface QueryBuilderViewModelType {
  getOptions(fieldName: string): Promise<QueryBuilderState>;
}

const createQueryBuilderViewModel = (elementId: string): QueryBuilderViewModelType => {
  let options: QueryBuilderState;
  const cacheKey: string = elementId;

  const fetchOptions = async (fieldName: string): Promise<QueryBuilderState> => {
    if (viewModelCache[cacheKey] && viewModelCache[cacheKey].data[fieldName]) {
      console.log('From cache', fieldName, viewModelCache[cacheKey].data[fieldName]);
      options = viewModelCache[cacheKey];
    } else {
      options = await doGetOptions(fieldName, cacheKey);
      viewModelCache[cacheKey] = options;
    }
    return options;
  };

  const getOptions = async (fieldName: string): Promise<QueryBuilderState> => {
    if (options && options.data[fieldName]) {
      return {
        ...options,
        data: options.data[fieldName] || []
      };
    }
    await fetchOptions(fieldName);
    return {
      ...options,
      data: options.data[fieldName] || []
    };
  };

  return {
    getOptions
  };
};

export default createQueryBuilderViewModel;
